const CORE_GROUP = 'core';

export const resolveEnabledGroups = (trackingGroups?: string): string[] | null => {
    if (!trackingGroups) return null;

    const groups = trackingGroups.split(',').map((group) => group.trim()).filter(Boolean);

    return [...groups, CORE_GROUP];
};
